import React, { useEffect, useState } from "react";
import useBodyScrollLock from "../../../../hooks/useBodyScrollLock";

const CheckIco = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
    <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const LockIco = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 10.5V8a4 4 0 018 0v2.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export const BookingProcessingOverlay = ({ flight = false }) => {
  const [i, setI] = useState(0);
  const STEPS = [
    "Securing your payment",
    "Confirming availability",
  ];
  if (flight) {
    STEPS.push("Generating your tickets", "Finalizing your booking");
  } else {
    STEPS.push("Generating your vouchers", "Finalizing your booking");
  }

  useBodyScrollLock();

  useEffect(() => {
    const t = setInterval(() => {
      setI((p) => (p < STEPS.length - 1 ? p + 1 : p));
    }, 1800);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="hw-bkovl" role="alertdialog" aria-busy="true" aria-label="Processing your booking">
      <div className="hw-bkovl--card">
        <div className="hw-bkovl--ring">
          <svg className="hw-bkovl--spinner" viewBox="0 0 50 50">
            <circle className="hw-bkovl--track" cx="25" cy="25" r="20" />
            <circle className="hw-bkovl--path" cx="25" cy="25" r="20" />
          </svg>
          <span className="hw-bkovl--lock">{LockIco}</span>
        </div>
        <div className="hw-bkovl--title">Processing your booking</div>
        <div className="hw-bkovl--sub">Hang tight, this only takes a moment.</div>
        <ul className="hw-bkovl--steps">
          {STEPS.map((s, idx) => (
            <li
              key={s}
              className={`hw-bkovl--step ${idx < i ? "is-done" : ""} ${idx === i ? "is-active" : ""}`}
            >
              <span className="hw-bkovl--dot">{CheckIco}</span>
              <span>{s}</span>
            </li>
          ))}
        </ul>
        <div className="hw-bkovl--note">Please don&apos;t close or refresh this window.</div>
      </div>
    </div>
  );
};
